'use strict'

var Marionette = require('marionette')
var App = require('app')
var _ = require('lodash')

var View = require('./view.js')
var PageModel = require('src/common/page-model')

var ClientShow = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      var self = this

      var client = options.client
      var id = options.id
      client || (client = App.globalChannel.request('client:entity', id))

      self.clients = App.globalChannel.request('client:entities')
      self.client = client

      var pageModel = new PageModel({
        buttons: [
          { label: 'edit', icon: true, slug: 'edit', action: 'client:edit', roles: ['super', 'admin'] }
        ],
        tabs: [
          { label: 'Nodes', slug: 'nodes', elementId: 'tab-nodes', roles: [] },
          { label: 'Groups', slug: 'groups', elementId: 'tab-groups', roles: [] },
          { label: 'Users', slug: 'users', elementId: 'tab-users', roles: [] },
          { label: 'Presets', slug: 'presets', elementId: 'tab-presets', roles: [] },
          { label: 'API Keys', slug: 'apikeys', elementId: 'tab-apikeys', roles: [] },
          { label: 'Reporting', slug: 'mailreports', elementId: 'tab-mailreports', roles: [] }

        ]
      })

      self.layout = self.getLayoutView(pageModel, client)

      this.listenTo(self.layout, 'client:edit', self.onEdit)
      this.listenTo(self.layout, 'tab:switch', self.onTabSwitch)

      App.rootLayout.showChildView('mainRegion', self.layout)
    },
    /* Event methods --------------------------------------------------------- */
    onEdit: function (args) {
      App.globalChannel.trigger('client:edit', {region: App.rootLayout.getRegion('dialogRegion'), model: args.model})
    },
    onTabSwitch: function (tab) {
      var self = this
      switch (tab.slug) {
        case 'nodes':
          App.globalChannel.trigger('client-nodes:list', {client: self.client, region: self.layout.getRegion('bodyRegion')})
          break
        case 'users':
          // App.globalChannel.trigger('client-users:list', {client: args.model, region: this.layout.contentRegion})
          App.globalChannel.trigger('client-users:list', {client: self.client, region: self.layout.getRegion('bodyRegion')})
          break
        case 'groups':
          App.globalChannel.trigger('client-groups:list', {client: self.client, region: self.layout.getRegion('bodyRegion')})

          break
        case 'presets':
          App.globalChannel.trigger('client-presets:list', {client: self.client, region: self.layout.getRegion('bodyRegion')})

          break
        case 'apikeys':
          App.globalChannel.trigger('client-apikeys:list', {client: self.client, region: self.layout.getRegion('bodyRegion')})
          break
        case 'mailreports':
          App.globalChannel.trigger('client-mailreports:list', {client: self.client, region: self.layout.getRegion('bodyRegion')})
          break
      }
    },
    /* Views ----------------------------------------------------------------- */
    getLayoutView: function (pageModel, model) {
      return new View.Layout({pageModel: pageModel, model: model})
    }
  })

  return new Controller(options)
}

module.exports = ClientShow



// WEBPACK FOOTER //
// ./js/modules/page-clients/show/index.js